<div class="container">
  <div class="cancelar"><p (click)="closeModal()">X</p></div>
  <div class="container-rol" *ngFor="let field of fields" >
    <div class="title-container" (click)="fieldSelected !== field.id ? fieldSelected = field.id : fieldSelected = 0">
      <h4>{{field.name}}</h4>
      <ion-icon slot="icon-only" [name]="fieldSelected == field.id ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
    </div>
    
    <div class="content-rol" *ngIf="fields.length > 0">
      <div class="toogle" *ngFor="let variable of variables" [hidden]="fieldSelected !== field.id">
        <p>{{variable.name}}</p>
        <ion-toggle [color]="'tertiary'"  [checked]="checkToggle(field.id, variable.id).isValid" (ionChange)=" update($event, field.id,variable.id)"></ion-toggle>
      </div>
      <div *ngIf="variables.length <=0">
        No hay variables disponibles 
      </div>
    </div>
   
  </div>
  <div *ngIf="fields.length <=0 && variables.length <=0 && isLoaded">
    Acción no permitida para este usuario
  </div>
  <div *ngIf="fields.length <=0 && !(fields.length <=0 && variables.length <=0) && isLoaded">
   No hay campos disponibles para este usuario
  </div>
  <ion-toast
    [isOpen]="isToastOpen"
    message="El permiso fue actualizado correctamente"
    [duration]="5000"
    color="success"
  ></ion-toast>
  <ion-toast
    [isOpen]="isToastOpenDelete"
    message="El permiso fue borrado correctamente"
    [duration]="5000"
    color="success"
  ></ion-toast>
</div>
